/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface UpdateFacilityServiceAreaRequest
 */
export interface UpdateFacilityServiceAreaRequest {
    /**
     * A 5-digit US ZIP code (e.g. "10001").
     * @type {string}
     * @memberof UpdateFacilityServiceAreaRequest
     */
    zip: string;
    /**
     * 
     * @type {FacilityServiceAreaStatus}
     * @memberof UpdateFacilityServiceAreaRequest
     */
    status: FacilityServiceAreaStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilityServiceAreaRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilityServiceAreaRequest
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilityServiceAreaRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateFacilityServiceAreaRequest interface.
 */
export function instanceOfUpdateFacilityServiceAreaRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zip" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UpdateFacilityServiceAreaRequestFromJSON(json: any): UpdateFacilityServiceAreaRequest {
    return UpdateFacilityServiceAreaRequestFromJSONTyped(json, false);
}

export function UpdateFacilityServiceAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityServiceAreaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zip': json['zip'],
        'status': FacilityServiceAreaStatusFromJSON(json['status']),
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function UpdateFacilityServiceAreaRequestToJSON(value?: UpdateFacilityServiceAreaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zip': value.zip,
        'status': FacilityServiceAreaStatusToJSON(value.status),
        'city': value.city,
        'state_id': value.state_id,
        'notes': value.notes,
    };
}

